import http from '@/plugins/axios/axios';

export default class SaldoBancoHorasService {

    salvar(requisicao) {       
        return http.post('/api/saldo-banco-horas/salvar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/saldo-banco-horas/excluir', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/saldo-banco-horas/buscar', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/saldo-banco-horas/listar', requisicao);
    }    

    zerar(requisicao) {       
        return http.post('/api/saldo-banco-horas/zerar', requisicao);
    }
}